module.exports = __webpack_public_path__ + "img/history2.896f51f3.png";